import type { NavigationGuard, RouteConfig, } from 'vue-router';

function loadNavigationGuard(name: keyof typeof import('./route-guards')): NavigationGuard {
	return (to, from, next) => {
		import('./route-guards').then((a) => {
			a[name](to, from, next);
		});
	};
}

export const DirectDebitRoutes: RouteConfig[] = [
	{
		path: '/set-up-direct-debit',
		component: () => import(/* webpackChunkName: "chunk-your-account-direct-debit" */'./pages/master.vue').then((m) => m.default),
		alias: '/amend-payment-details',
		beforeEnter: loadNavigationGuard('LoadDirectDebitDetails'),
		children: [
			{ path: `direct-debit-details`, name: 'DirectDebitDetails', component: () => import(/* webpackChunkName: "chunk-your-account-direct-debit" */'./pages/setup-detail.vue').then((m) => m.default), },
			{ path: `bank-details`, name: 'DirectDebitBankDetails', component: () => import(/* webpackChunkName: "chunk-your-account-direct-debit" */'./pages/bank-details.vue').then((m) => m.default), },
			{ path: `confirm-detail`, name: 'ConfirmDirectDebit', component: () => import(/* webpackChunkName: "chunk-your-account-direct-debit" */'./pages/confirm-detail.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresBankDetails'), },
			{ path: `success`, name: 'DirectDebitSuccess', component: () => import(/* webpackChunkName: "chunk-your-account-direct-debit" */'./pages/direct-debit-success.vue').then((m) => m.default), },
			{ path: `successful`, name: 'DirectDebitSuccessForced', component: () => import(/* webpackChunkName: "chunk-your-account-direct-debit" */'./pages/direct-debit-success.vue').then((m) => m.default), },
			{ path: '', redirect: 'direct-debit-details', },
		],
	},
];
